import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import mainimg from "./assets/main-visual-3.jpg";

const MySwiper = () => {
  return (
    <Swiper>
      <SwiperSlide>
        <div
          className="main-bg-1"
          style={{ backgroundImage: `url(${mainimg})` }}
        ></div>
      </SwiperSlide>
    </Swiper>
  );
};

export default MySwiper;
